import {css} from "lit";

export const iconButtonStyles = css`
	button {
		display: block;
		padding: 0;
		border: none;
		background-color: transparent;
		cursor: pointer;
		font-size: inherit;
		line-height: inherit;
	}
	button i:not(.icon-mask) {
		opacity: 0.55;
	}

	button:hover i:not(.icon-mask), button:focus i:not(.icon-mask) {
		opacity: 0.8;
	}

	button:focus {
		outline: thin dotted;
		outline-offset: 0px;
	}

	button:disabled {
		pointer-events: none;
		opacity: 0.4;
	}
	button:disabled:hover {
		opacity: 0.4;
	}

	i[class*="icon-"] {
		display: block;
		/** Declaring size this way allows size adjustments via font-size wherever we want **/
		height: 1em;
		width: 1em;
	}
	i[class*="icon-"].icon-mask {
		background-image: none;
		mask-size: 1em;
		-webkit-mask-size: 1em;
	}

	/** Note: Used for citation refresh button **/
	@keyframes spin {
		100% {
			transform: rotate(360deg);
		}
	}

	/** ProQuest integration only **/
	.__pq-int__ {
		border-radius: 6px !important;
		padding: 6px !important;
		margin: 0 !important;
	}

	.__pq-int__:hover, .__pq-int__:focus {
		box-shadow: none !important;
		background-color: #cececf;
	}
`;
